<template>
  <b-sidebar
    id="add-new-product"
    :visible="isAddNewProductSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-product-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Product Item</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- Body -->
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <b-row>
              <b-col cols="12" md="12">
                <p>Original Image:</p>
                <img
                  style="width: 180px"
                  v-if="productData.image_url"
                  :src="productData.image_url"
                />
                <b-form-group label="Payment Image" label-for="image_path">
                  <el-upload
                    ref="upload"
                    class="avatar-uploader"
                    list-type="picture-card"
                    :action="uploadUrl"
                    :headers="headerObj"
                    name="image_file"
                    :file-list="fileList"
                    multiple
                    :limit="1"
                    :data="productData"
                    :on-change="onChange"
                    :on-remove="toggleUpload"
                    :before-remove="beforeRemove"
                    :auto-upload="false"
                    :class="{ hideUpload: !showUpload }"
                  >
                    <img
                      v-if="productData.image_path && false"
                      :src="productData.image_path"
                      class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group label="Category">
                  <v-select
                    v-model="productData.category_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="categoryOptions"
                    label="name"
                    :reduce="(val) => val.id"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Model">
                  <!-- rules="required" -->
                  <b-form-group label="Model">
                    <b-form-input
                      v-model="productData.model"
                      type="text"
                      placeholder="Model"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Sku">
                  <!-- rules="required" -->
                  <b-form-group label="Sku">
                    <b-form-input
                      v-model="productData.sku"
                      type="text"
                      placeholder="Sku"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Mpn">
                  <!-- rules="required" -->
                  <b-form-group label="Mpn">
                    <b-form-input
                      v-model="productData.mpn"
                      type="text"
                      placeholder="Mpn"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="Price"
                  rules="required"
                >
                  <b-form-group class="required" label="Price">
                    <b-form-input
                      v-model="productData.price"
                      type="number"
                      step="0.0001"
                      placeholder="Price"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider
                  rules="required"
                  #default="validationContext"
                  name="Name"
                >
                  <b-form-group class="required" label="Name">
                    <b-form-input
                      v-model="productData.name"
                      type="text"
                      placeholder="Name"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="Short Description"
                >
                  <b-form-group label="Short Description">
                    <b-form-input
                      v-model="productData.short_description"
                      type="text"
                      placeholder="Short Description"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group label="Description" label-for="description">
                  <quill-editor
                    id="quil-content"
                    v-model="productData.description"
                    :options="editorOption"
                    class="border-bottom-0"
                  />
                  <div
                    id="quill-toolbar-description"
                    class="d-flex justify-content-end border-top-0"
                  >
                    <!-- Add a bold button -->
                    <button class="ql-bold" />
                    <button class="ql-italic" />
                    <button class="ql-underline" />
                    <button class="ql-align" />
                    <button class="ql-link" />
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="Meta Title"
                >
                  <b-form-group label="Meta Title">
                    <b-form-input
                      v-model="productData.meta_title"
                      type="text"
                      placeholder="Meta Title"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <validation-provider
                  #default="validationContext"
                  name="Meta Keyword"
                >
                  <b-form-group label="Meta Keyword">
                    <b-form-input
                      v-model="productData.meta_keyword"
                      type="text"
                      placeholder="Meta Keyword"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  label="Meta Description"
                  label-for="meta_description"
                >
                <b-form-textarea
                    id="meta_description"
                    v-model="productData.meta_description"
                    placeholder="Meta Description"
                    rows="3"
                    max-rows="6"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <div class="d-flex mt-2 mb-5">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                Save
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant=""
                class="mr-2"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template></b-sidebar
  >
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BCol,
  BMedia,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BImg,
  BCardText,
  BOverlay,
  BFormCheckboxGroup,
  BFormCheckbox,
  BRow,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, email } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { quillEditor } from "vue-quill-editor";
import productStoreModule from "../productStoreModule";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

export default {
  directives: {
    Ripple,
  },
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BCol,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BImg,
    BCardText,
    BOverlay,
    BFormCheckboxGroup,
    BFormCheckbox,
    BRow,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    vSelect,
  },
  model: {
    prop: "isAddNewProductSidebarActive",
    event: "update:is-add-new-product-sidebar-active",
  },
  props: {
    isAddNewProductSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
    };
  },
  methods: {
    toggleUpload() {
      this.showUpload = !this.showUpload;
    },
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    beforeRemove(file) {
      if (
        file.url ==
        process.env.VUE_APP_IMAGE_URL + this.productData.image_path
      ) {
        this.removeExistingPic = true;
        this.productData.image_path = null;
      }
    },
    onChange(file, fileLists) {
      this.showUpload = !this.showUpload;
      console.log(file.raw);
      this.productData.file = file.raw;
    },
    hide() {
      this.isAddNewProductSidebarActive = false;
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure",
        showCancelButton: true,
        confirmButtonText: "Save",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;

          let formData = new FormData();
          formData.append("file", this.productData.file);
          formData.append("id", this.productData.id);
          formData.append("model", this.productData.model);
          formData.append("sku", this.productData.sku);
          formData.append("mpn", this.productData.mpn);
          formData.append("price", this.productData.price);
          formData.append("name", this.productData.name);
          formData.append(
            "short_description",
            this.productData.short_description
          );
          formData.append("description", this.productData.description);
          formData.append("meta_title", this.productData.meta_title);
          formData.append("meta_keyword", this.productData.meta_keyword);
          formData.append(
            "meta_description",
            this.productData.meta_description
          );
          if (this.productData.category_id) {
            formData.append("category_id", this.productData.category_id);
          }
          store
            .dispatch("product/addProduct", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.$emit("update:is-add-new-product-sidebar-active", false);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props, { emit }) {
    const showUpload = ref(true);
    const isSortDirDesc = ref(true);
    const fileList = ref([]);
    const loading = ref(false);
    const APP_CLIENT_STORE_MODULE_NAME = "product";
    const uploadUrl = ref("#");
    const headerObj = {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    };

    if (!store.hasModule(APP_CLIENT_STORE_MODULE_NAME))
      store.registerModule(APP_CLIENT_STORE_MODULE_NAME, productStoreModule);

    const blankData = ref({
      id: 0,
      model: "",
      sku: "",
      mpn: "",
      price: 0,
      name: "",
      description: "",
      short_description: "",
      meta_title: "",
      meta_description: "",
      meta_keyword: "",
      category_id: null,
    });

    const productData = ref(JSON.parse(JSON.stringify(blankData)));

    const resetproductData = () => {
      productData.value = JSON.parse(JSON.stringify(blankData));
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetproductData);

    watch(
      () => props.isAddNewProductSidebarActive,
      () => {
        if (props.isAddNewProductSidebarActive) {
          // productData.value = JSON.parse(JSON.stringify(props.data));
          productData.value = { ...props.data };
        }
      }
    );

    const editorOption = {
      modules: {
        toolbar: "#quill-toolbar-description",
      },
      placeholder: "Description",
    };
    const editorOption2 = {
      modules: {
        toolbar: "#quill-toolbar-meta-description",
      },
      placeholder: "Meta Description",
    };

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      productData,
      editorOption,
      editorOption2,
      isSortDirDesc,
      showUpload,
      uploadUrl,
      headerObj,
      fileList,
    };
  },
};
</script>
